import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { searchCatalogOptions } from "../../app/actions/searchKeyTermActions";

const SearchTermTypeahead = ({
  fieldKey,
  label,
  required,
  sourceKind,
  catalogtypeId,
  topicId,
  disabled,
  value,
  onChange
}) => {
  const { t } = useTranslation();
  const [text, setText] = useState(value?.label || "");
  const [options, setOptions] = useState([]);
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => {
    setText(value?.label || "");
  }, [value?.id, value?.label]);

  useEffect(() => {
    if (disabled) {
      setOpen(false);
      setOptions([]);
    }
  }, [disabled, topicId]);

  useEffect(() => {
    const onDocClick = (event) => {
      if (boxRef.current && !boxRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const handle = setTimeout(async () => {
      const rows = await searchCatalogOptions(sourceKind, text, catalogtypeId, topicId);
      setOptions(rows);
    }, sourceKind === "ciiu" ? 200 : 0);
    return () => clearTimeout(handle);
  }, [open, text, sourceKind, catalogtypeId, topicId]);

  const pick = (option) => {
    onChange(option);
    setText(option.label);
    setOpen(false);
  };

  const clear = () => {
    onChange(null);
    setText("");
    setOptions([]);
  };

  return (
    <div className="mb-3 position-relative" ref={boxRef}>
      <label className="form-label" htmlFor={`term-${fieldKey}`}>
        {label}
        {required ? " *" : ""}
      </label>
      <div className="input-group">
        <input
          id={`term-${fieldKey}`}
          className="form-control"
          autoComplete="off"
          value={text}
          disabled={disabled}
          placeholder={disabled
            ? t("specialist.feeder.term.question-needs-topic", "Selecciona un tópico")
            : t("specialist.feeder.term.search-placeholder", "Escribe para buscar")}
          onFocus={() => {
            if (!disabled) {
              setOpen(true);
            }
          }}
          onChange={(event) => {
            setText(event.target.value);
            setOpen(true);
            if (!event.target.value) {
              onChange(null);
            }
          }}
        />
        {value?.id && (
          <button type="button" className="btn btn-outline-secondary" onClick={clear}>
            ×
          </button>
        )}
      </div>
      {open && options.length > 0 && (
        <div className="list-group position-absolute shadow-sm w-100" style={{ zIndex: 20, maxHeight: "220px", overflowY: "auto" }}>
          {options.map((option) => (
            <button
              key={option.id}
              type="button"
              className="list-group-item list-group-item-action py-1"
              onClick={() => pick(option)}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchTermTypeahead;
